export default __webpack_public_path__ + "static/media/LOGO_SIES_170_x_115_px.d2b5e241.png";